import {
  backend_url,
  uninterceptedAxiosInstance,
} from "../common/commonVariables";
export const updateCategory = async (id, name) => {
  try {
    let params = {
      name,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + `categories/${id}`,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
    };
  }
};
export const deleteCategory = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };
    const response = await uninterceptedAxiosInstance.post(
      backend_url + `categories/removeCategories`,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
    return {
      status: err?.response?.status,
    };
  }
};
export const createCategory = async (
  name,
  organisationId = null,
  createdByUser = null
) => {
  try {
    let params = {
      name,
      createdByUser,
      organisation: organisationId,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "categories",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
    };
  }
};

export const createBulkCategory = async (data = [], organisationId = null) => {
  try {
    let params = {
      data,
      organisation: organisationId,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "categories/import",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};
